@if (!cs.step4.skipped) {
  <div class="summary-part"
    >
    <div class="summary-part-title">
      <div class="title">{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP4.TAB' | translate }}</div>
      <div class="action"
      (click)="gotoStep(3)">{{ 'BUTTON.MODIFY' | translate }}</div>
    </div>
    @if (cs.step4.valid) {
      <!-- <div class="summary-part-row" *ngFor="let contact of [cs.step4.main].concat(cs.step4.contacts)">
      <div class="summary-field label">{{ contact.firstName + ' ' + contact.lastName }}</div>
      <div class="summary-field value">{{ contact.email }}</div>
    </div> -->
    <div class="summary-part-row"
      [innerHtml]="cs.step4.toSummary()">
    </div>
  }
  @if (!cs.step4.valid) {
    <div class="summary-part-row">
      {{ 'ITSM.CREATESERVICEREQUEST.STEPS.NOTCOMPLETED' | translate }}
    </div>
  }
</div>
}
